module.exports = __webpack_public_path__ + "static/img/slider4.7adbf93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider4.png
// module id = alM6
// module chunks = 1